@if (documentCardData) {
  <div class="document-card" nz-row>
      <div nz-col class="header-container">
        <div>
          <img [src]="'/public/assets/images/' + documentCardData.icon" />
          <p class="doc-name">{{ documentCardData.title }}</p>
        </div>
        @if(isPopoverVisible) {
          <span #popover="nzPopover" nz-icon nzType="more" nzTheme="outline" nz-popover nzPopoverTrigger="click" [nzPopoverContent]="recordActions"></span>
          <ng-template #recordActions >
            <!-- <button class="btn-popover" nz-button nzType="link" (click)="handleActionCard({eventType: 'view', idDoc: documentCardData.id}); closePopover(popover)">{{ 'buttons.view' | translate | titlecase }}</button> -->
            <button class="btn-popover" nz-button nzType="link" (click)="handleActionCard({eventType: 'download', idDoc: documentCardData.id, docName: documentCardData.title}); closePopover(popover)">{{ 'buttons.download' | translate | titlecase }}</button>
            <button class="btn-popover" nz-button nzType="link" (click)="handleActionCard({eventType: 'delete', idDoc: documentCardData.id, docName: documentCardData.title}); closePopover(popover)">{{ 'buttons.delete' | translate | titlecase }}</button>
          </ng-template>
        }
      </div>
      <div class="info-container">
        <p class="doc-size">{{ documentCardData.date }}</p>
        <p class="doc-type">
          @if (documentCardData.additional_text) {
            {{ documentCardData.additional_text | translate }}
          }
          <span class="doc-type-value">{{ documentCardData.type }}</span>
        </p>
      </div>

  </div>
}
